module.exports = __webpack_public_path__ + "static/media/pawn.1af2ebe9.png";